module.exports = __webpack_public_path__ + "static/media/gift-registry-1920.3476c4ec.jpg";